import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';

import ReactModal from 'react-modal';
import { Button, Card } from 'react-bootstrap';
import { makeGetToken } from 'lib/selector';
import { translate } from 'react-i18next';
import { required } from 'utils/validation';
import RenderFieldCheckbox from 'components/input/renderCheckboxFilter';
import RenderFieldInput from 'components/input/renderFieldInput';

import { ReactComponent as IcCloseFilter } from 'assets/img/icon/ic_close_filter.svg';
import styled from 'styled-components';
import { log } from 'utils';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    width: '346px',
    transform: 'translate(-50%, -50%)',
    bottom: 'auto',
    backgroundColor: '#1C192C',
    border: 'none',
  },
  overlay: {
    backgroundColor: 'transparent',
    zIndex: '3',
  },
};

const StyledHeader = styled.span`
  color: ${props => props.theme === 'dark' ? '#ececec' : '#000'};
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
`;

function SaveFilterModal(props) {
  const {
    hasNew,
    onClose,
    saveFilter,
    submitting,
    handleSubmit,
    filterName,
    filterDef,
    t,
    theme
  } = props;

  const formRef = React.useRef();

  function submit(values) {
    const { filterName, filterDef } = values;
    saveFilter(filterName, filterDef);
  }

  function onUpdateOver() {
    // log(filterName)
    if (!filterName) {
      setTimeout(() => {
        formRef.current && formRef.current.dispatchEvent(new Event('submit'));
      }, 100);
    } else {
      // log('onUpdateOver')

      saveFilter(filterName, filterDef, 'RU');
    }
  }

  return (
    <ReactModal
      isOpen={true}
      contentLabel="onRequestClose Example"
      onRequestClose={onClose}
      shouldCloseOnOverlayClick={true}
      style={customStyles}
    >
      <Card style={{ border: 'none', background: 'transparent' }}>
        <Card.Body style={{ backgroundColor: 'var(--bg-th-even)' }}>
          <div className="d-flex align-items-center justify-content-between mb-3">
            <StyledHeader theme={theme}>{t('algo.lcp.txt-Save')}</StyledHeader>
            <a onClick={onClose}>
              <IcCloseFilter style={{ height: '12px', with: '12px' }} />
            </a>
          </div>
          <form
            className="form-trade form-search-head form-filter-add"
            onSubmit={handleSubmit(submit)}
            ref={formRef}
          >
            <Field
              name="filterName"
              className="form-control input-filter fz-14"
              placeholder={t('algo.lcp.txt-Filters')}
              autoFocus={true}
              validate={[required]}
              component={RenderFieldInput}
            />
            {/* <div className="mt-3 mr-2">
              <Field
                name="filterDef"
                component={RenderFieldCheckbox}
                labelName="Đặt làm mặc định"
                className="filter-modal"
              />
            </div> */}

            <div className="d-flex justify-content-end mt-2">
              {!hasNew && (
                <Button
                  variant="outline-primary"
                  type="button"
                  disabled={submitting}
                  onClick={() => onUpdateOver()}
                >
                  {t('algo.lcp.txt-Save-2')}
                </Button>
              )}
              <Button type="submit" disabled={submitting} className="ml-2">
                {t('algo.lcp.txt-Save-new')}
              </Button>
            </div>
          </form>
        </Card.Body>
      </Card>
    </ReactModal>
  );
}

SaveFilterModal = reduxForm({
  form: 'savefilterform',
  enableReinitialize: true,
})(SaveFilterModal);

const selector = formValueSelector('savefilterform');

const makeMapStateToProps = () => {
  const getToken = makeGetToken();

  const mapStateToProps = (state, props) => {
    // log(state)
    const { filterName, filterDef } = selector(state, 'filterName', 'filterDef');

    const {headerFilter} = props
    // console.log(headerFilter)
    return {
      token: getToken(state),

      filterName,
      filterDef,
      initialValues: {
        filterName: headerFilter?.name || '',
        filterDef: true,
      },
    };
  };
  return mapStateToProps;
};

export default connect(makeMapStateToProps)(
  translate('translations')(SaveFilterModal)
);
